// extracted by mini-css-extract-plugin
module.exports = {"QRCodeWrapper":"QRCode_QRCodeWrapper__F3ANm"};